import React from "react";
import Meter from "./Meter";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";
import { skills } from "../data/resume";

const Skills = () => (
    <section id="skills" aria-labelledby="skills-title" className="py-10 md:py-14">
        <SectionHeading id="skills-title" index="03" label="Stack" title="Technical" accent="Skills" />

        <ul className="mt-8 grid gap-x-10 md:mt-10 md:grid-cols-2">
            {skills.map((skill, index) => (
                <Reveal as="li" key={skill.group} delay={(index % 2) * 90} className="border-t border-fg/10 py-5">
                    <div className="flex items-center justify-between gap-4">
                        <h3 className="font-semibold">{skill.group}</h3>
                        <Meter level={skill.level} label={`${skill.group} proficiency`} />
                    </div>
                    <ul className="mt-3 flex flex-wrap gap-1.5">
                        {skill.items.map((item) => (
                            <li
                                key={item}
                                className="cursor-default rounded-full border border-fg/10 px-2.5 py-1 text-[13px] text-muted transition-colors duration-300 hover:border-accent hover:text-fg"
                            >
                                {item}
                            </li>
                        ))}
                    </ul>
                </Reveal>
            ))}
        </ul>
    </section>
);

export default Skills;
